import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd';
import { BankMaster } from 'src/app/Models/BankMaster';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-bank-drawer',
  templateUrl: './bank-drawer.component.html',
  styleUrls: ['./bank-drawer.component.css']
})

export class BankDrawerComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: BankMaster;
  @Input() drawerVisible: boolean;
  isSpinning = false;

  constructor(private api: ApiService, private message: NzNotificationService) { }

  ngOnInit() { }

  close(myForm: NgForm): void {
    this.drawerClose();
    this.reset(myForm);
  }

  reset(myForm: NgForm) {
    myForm.form.reset();
  }

  save(addNew: boolean, myForm: NgForm): void {
    var isOk = true;

    if (this.data.NAME != undefined) {
      if (this.data.NAME.trim() != '') {
        if (!this.api.checkTextBoxIsValid(this.data.NAME)) {
          isOk = false;
          this.message.error("Please Enter Valid Bank Name", "");
        }

      } else {
        isOk = false;
        this.message.error("Please Enter Valid Bank Name", "");
      }

    } else {
      isOk = false;
      this.message.error("Please Enter Valid Bank Name", "");
    }

    if (this.data.SHORT_NAME != undefined) {
      if (this.data.SHORT_NAME.trim() != '') {
        if (!this.api.checkTextBoxIsValid(this.data.SHORT_NAME)) {
          isOk = false;
          this.message.error("Please Enter Valid Short Name", "");
        }

      } else {
        isOk = false;
        this.message.error("Please Enter Valid Short Name", "");
      }

    } else {
      isOk = false;
      this.message.error("Please Enter Valid Short Name", "");
    }

    if (isOk) {
      this.isSpinning = true;

      if (this.data.ID) {
        this.api.updateBank(this.data).subscribe(successCode => {
          if (successCode['code'] == "200") {
            this.message.success("Bank Details Updated Successfully", "");
            this.isSpinning = false;

            if (!addNew)
              this.close(myForm);

          } else {
            this.message.error("Bank Details Updation Failed", "");
            this.isSpinning = false;
          }
        });

      } else {
        this.api.createBank(this.data).subscribe(successCode => {
          if (successCode['code'] == "200") {
            this.message.success("Bank Details Added Successfully", "");
            this.isSpinning = false;

            if (!addNew)
              this.close(myForm);

            else {
              this.data = new BankMaster();
            }

          } else {
            this.message.error("Bank Details Creation Failed", "");
            this.isSpinning = false;
          }
        });
      }
    }
  }

  omit(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }

    return true;
  }
}
